import { render, staticRenderFns } from "./ErgebnisAndChart.vue?vue&type=template&id=5bef1529&scoped=true"
import script from "./ErgebnisAndChart.vue?vue&type=script&lang=js"
export * from "./ErgebnisAndChart.vue?vue&type=script&lang=js"
import style0 from "./ErgebnisAndChart.vue?vue&type=style&index=0&id=5bef1529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bef1529",
  null
  
)

export default component.exports